// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v2.0.0-193-gf41459d",
    "hash": "gf41459d",
    "distance": 193,
    "tag": "v2.0.0",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v2.0.0",
        "major": 2,
        "minor": 0,
        "patch": 0,
        "prerelease": [],
        "build": [],
        "version": "2.0.0"
    },
    "suffix": "193-gf41459d",
    "semverString": "2.0.0+193.gf41459d",
    "version": "2.0.0"
};
/* tslint:enable */
